import { ConcessionStatus, UserStatus } from './../constants/app.constants';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { RegistrationService } from '../registration/registration.service';
import { DestroyableComponent } from '../common/destroyable.component';
import { CommonService } from '../services/common.service';
import { EnvironmentService } from '../services/environment.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ConcessionCompanyDataComponent } from '../concession-registration/concession-basic-profile/concession-company-data/concession-company-data.component';
import { ConcessionTechnicianDataComponent } from '../concession-registration/concession-basic-profile/concession-technician-data/concession-technician-data.component';
import { finalize } from 'rxjs/operators';
import { DataConcessionScenario } from '../concession-registration/concession-basic-profile/concession-basic-profile.component';
import { KeyValueData, TechnicianApplicationData } from '../domains/common.domain';
import { prepareCompanyData } from '../concession-registration/concession-registration.utility';
import { DataConcessionValidationService } from '../concession-registration/concession-basic-profile/data-concession-validation/data-concession-validation.service';
import { ConcessionFilesComponent } from '../concession-registration/concession-basic-profile/concession-files/concession-files.component';
import { ConcessionDocumentsStateModel } from '../concession-registration/concession-basic-profile/concession-files/concession-files.models';
import { UserService } from '../services/user.service';
import { ErrorService } from '../services/error/error.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-data-gop',
  templateUrl: './data-gop.component.html',
  styleUrls: ['./data-gop.component.scss'],
})
export class DataGopComponent extends DestroyableComponent implements OnInit {
  companyId: number;
  technicianId: number;
  scenario = this.environmentService.dataForConcessionValidationScenario;
  isLoading: boolean;
  technicianApplication: TechnicianApplicationData;

  companyDataForm: FormGroup;
  technicianDataForm: FormGroup;

  technicianDataFormPureValue: any; // used for resetting the technicianDataForm
  companyDataFormPureValue: any; // used for resetting the companyDataForm
  dataConcessionScenario: DataConcessionScenario = this.environmentService.dataForConcessionValidationScenario;
  concessionValidationInitial: {
    bdewTechnicianId: any;
    occupation: any;
    hasWeldingLicense: boolean;
    isRegisterForDistrictHeating: boolean;
    role: any;
    validUntil: any;
    registeredCommodities: { power: boolean; gas: boolean; water: boolean; heating: boolean };
  };
  concessionDocumentsState: ConcessionDocumentsStateModel;
  userStatus: KeyValueData = UserStatus;
  isDataConcessionValidationValid: boolean = false;

  get concessionManagementDataValidationForm(): FormGroup {
    return this.dataConcessionValidationService.form;
  }

  technicianApplicationId: string;

  constructor(
    private localStorageService: LocalStorageService,
    private registrationService: RegistrationService,
    private commonService: CommonService,
    private environmentService: EnvironmentService,
    private dataConcessionValidationService: DataConcessionValidationService,
    private userService: UserService,
    private errorService: ErrorService,
    private ref: ChangeDetectorRef,
    private router: Router
  ) {
    super();
  }

  @ViewChild('companyDataElement') companyChildElement: ConcessionCompanyDataComponent;
  @ViewChild('technicianDataElement') technicianChildElement: ConcessionTechnicianDataComponent;
  @ViewChild('concessionFiles') concessionFilesComponent: ConcessionFilesComponent;

  ngOnInit(): void {
    this.companyDataForm = this.registrationService.companyDataFG;
    this.technicianDataForm = this.registrationService.technicianDataFG;

    this.technicianId = parseInt(this.localStorageService.getItem('technician_id'));
    this.LoadTechnicianApplication();
  }

  get isExpired() {
    return this.technicianApplication?.status.toUpperCase() === ConcessionStatus.expired;
  }

  get isWaitingForApproval() {
    return [ConcessionStatus.renew_requested, ConcessionStatus.submitted].includes(this.technicianApplication?.status.toUpperCase());
  }

  async saveChanges() {
    this.isLoading = true;
    try {
      const shouldAutoUpdatePartially = this.shouldRevokeConcession();

      if (this.companyDataForm.dirty) {
        await this.companyChildElement.updateCompany({ isFromAutosave: false });
        this.saveCompanyFormState();
      }

      if (this.technicianDataForm.dirty || this.concessionManagementDataValidationForm.dirty) {
        await this.technicianChildElement.updateTechnician({ isFromAutosave: false });
        this.saveTechnicianFormState();
      }

      if (this.concessionManagementDataValidationForm.dirty) {
        this.updateTechnicianApplication({ qualificationType: this.concessionManagementDataValidationForm.value.occupation });
        this.dataConcessionValidationService.saveFormState();
      }

      if (this.concessionManagementDataValidationForm.value.isRegisterForDistrictHeating) {
        this.concessionFilesComponent.saveChanges();
      }

      const updateData = {
        technician_application: [
          {
            status: ConcessionStatus.renew_requested,
          },
        ],
      };

      if (this.dataConcessionScenario === 'Mixed' && this.concessionManagementDataValidationForm.value.hasBdewId) {
        try {
          await this.preventLeak(
            this.registrationService.updateTechnicianApplicationWithConcessionValidation({
              technicianId: this.technicianId,
              shouldAutoUpdatePartially: shouldAutoUpdatePartially,
              concessionRegistrationId: this.concessionManagementDataValidationForm.value.bdewTechnicianId,
              technicianApplicationId: +this.technicianApplicationId,
              technicianFirstName: this.technicianDataForm.controls['first_name'].value,
              technicianLastName: this.technicianDataForm.controls['last_name'].value,
            })
          ).toPromise();
        } catch (error) {
          this.updateDataConcessionValidationStatus(false);
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(
            {
              result: 'error',
              message: error.error.message,
            },
            true
          );
        }

        if (shouldAutoUpdatePartially) {
          await this.userService.reloadUserData(this.technicianId);
        }
      } else {
        await this.preventLeak(this.registrationService.updateTechnicianApplication(updateData, this.technicianApplicationId)).toPromise();
        await this.userService.reloadUserData(this.technicianId);
      }
    } finally {
      this.isLoading = false;
    }

    this.resetForm();
    this.isLoading = false;
  }

  isDisableSaveForm(): boolean {
    return (
      (!this.companyDataForm.dirty &&
        !this.technicianDataForm.dirty &&
        !this.concessionManagementDataValidationForm?.dirty &&
        !this.concessionDocumentsState?.dirty) ||
      !this.companyDataForm.valid ||
      !this.technicianDataForm.valid ||
      !this.concessionManagementDataValidationForm?.valid ||
      (!this.concessionDocumentsState?.isValid && this.concessionManagementDataValidationForm?.value.isRegisterForDistrictHeating) ||
      !this.isDataConcessionValidationValid
    );
  }

  updateDataConcessionValidationStatus(isValid: boolean) {
    this.isDataConcessionValidationValid = isValid;
    this.ref.detectChanges();
  }

  private shouldRevokeConcession() {
    if (this.scenario === 'Manual') {
      return true;
    }
    const userHasDistrictHeatingInitially = this.dataConcessionValidationService.formPureValue?.isRegisterForDistrictHeating;
    const isRegisteredForDistrictHeating = !!this.concessionManagementDataValidationForm.value.isRegisterForDistrictHeating;
    const hasActivatedDistrictHeating = isRegisteredForDistrictHeating && !userHasDistrictHeatingInitially;

    return (
      isRegisteredForDistrictHeating &&
      (hasActivatedDistrictHeating ||
        this.companyDataForm.dirty ||
        this.technicianDataForm.dirty ||
        this.concessionDocumentsState.dirty ||
        this.concessionManagementDataValidationForm.controls.occupation.dirty ||
        this.concessionManagementDataValidationForm.controls.hasWeldingLicense.dirty)
    );
  }

  resetForm() {
    this.technicianDataForm.reset(this.technicianDataFormPureValue);
    this.companyDataForm.reset(this.companyDataFormPureValue);
    this.dataConcessionValidationService.resetForm();
    this.concessionFilesComponent.resetChanges();
  }

  concessionDocumentsStateChange(state: ConcessionDocumentsStateModel) {
    this.concessionDocumentsState = state;
  }

  private LoadTechnicianApplication() {
    this.isLoading = true;
    this.preventLeak(this.registrationService.getTechnicianApplication(this.technicianId, 'technician_id'))
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(response => {
        this.companyId = parseInt(response.technician_application[0].company_id);
        this.technicianApplicationId = response.technician_application[0].ta_id;
        this.technicianApplication = response.technician_application[0];

        this.initTechnicianFormData(response);
        this.initCompanyFormData(response);

        this.concessionValidationInitial = {
          bdewTechnicianId: response.technician_application[0]?.technician[0]?.bdew_id,
          occupation: response.technician_application[0]?.qualification_type,
          hasWeldingLicense: response.technician_application[0]?.technician[0]?.welding_license === '1',
          isRegisterForDistrictHeating: response.technician_application[0]?.technician[0]?.concession_district_heating === '1',
          role: response.technician_application[0]?.technician[0]?.role,
          validUntil: response.technician_application[0]?.technician[0]?.concession_valid_until,
          registeredCommodities: {
            power: response.technician_application[0]?.technician[0]?.concession_power === '1',
            gas: response.technician_application[0]?.technician[0]?.concession_gas === '1',
            water: response.technician_application[0]?.technician[0]?.concession_water === '1',
            heating: response.technician_application[0]?.technician[0]?.concession_district_heating === '1',
          },
        };
      });
  }

  applicationIsApproved(): boolean {
    return (
      this.technicianApplication?.status === UserStatus.ISSUED || this.technicianApplication?.status === UserStatus.AUTOMATICALLY_REVOKED
    );
  }

  private initTechnicianFormData(response: any): void {
    if (!response.technician_application[0]?.technician[0]) return;

    let birthday = response.technician_application[0].technician[0].birthday;
    birthday = this.commonService.parseDateForUI(birthday);
    response.technician_application[0].technician[0].birthday = birthday;
    this.technicianDataForm.patchValue(response.technician_application[0].technician[0]);
    this.technicianDataForm.controls['qualification_type'].disable(); // not relevant for this page

    if (this.scenario === 'Mixed') {
      this.technicianDataForm.addControl('technician_id', new FormControl(response.technician_application[0].technician[0].technician_id));
    }

    this.saveTechnicianFormState();
  }

  private initCompanyFormData(response: any) {
    let companyData = response.technician_application[0].company[0];
    companyData = prepareCompanyData(companyData);
    this.companyDataForm.patchValue(companyData);
    this.saveCompanyFormState();
  }

  private saveTechnicianFormState() {
    this.technicianDataFormPureValue = this.technicianDataForm.value;
  }

  private saveCompanyFormState() {
    this.companyDataFormPureValue = this.companyDataForm.value;
  }

  private async updateTechnicianApplication(data: { companyId?: string; qualificationType?: string }): Promise<void> {
    if (!this.technicianApplicationId) return;

    const updateData = {
      technician_application: [
        {
          company_id: data.companyId,
          qualification_type: data.qualificationType,
        },
      ],
    };

    await this.preventLeak(this.registrationService.updateTechnicianApplication(updateData, this.technicianApplicationId)).toPromise();
  }
}
